import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from '@/App'
import '@/i18n'
import '@/index.css'
import '@fontsource/fredoka/400.css'
import '@fontsource/fredoka/500.css'
import '@fontsource/fredoka/600.css'
import '@fontsource/fredoka/700.css'
import '@fontsource/zcool-kuaile/400.css'
import 'remixicon/fonts/remixicon.css'
import { initOklchFallback } from '@/utils/zzzfun-oklch-fallback'

// 旧内核颜色兜底：必须在首次渲染前执行，避免颜色闪跳
initOklchFallback()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)